import { Injectable, Injector } from '@angular/core';

 
import {DatabaseManagerProvider} from '../../storage-manager/database-manager';
import { LoggerService } from '../../../app/services/logger.service';
 


import { Friend } from '../../../bayadic-shared-models/classes/user/friend/Friend';


@Injectable()
export class FriendsDatabaseManagerProvider extends DatabaseManagerProvider {
  //private friendTableName = "friends";
  constructor(
     public injector : Injector,
     public logger: LoggerService
  ) {

     super(injector, logger);
     
     this.init().then(()=>{
        // this.createFriendsTable();
     });
     
  }
  add(friend : Friend){
    
    this.logger.debug("adding friend to database");
    let sqlString = 'INSERT OR IGNORE INTO friends (friendID,chatID,email,name,family) VALUES ("'+
    friend.userID+'","'+
    friend.chatID+'","'+
    friend.email+'","'+
    friend.name+'","'+
    friend.familyName+'")';
    this.databaseObj.executeSql(sqlString).then(
      result=>{
          this.logger.debug("friend has beend added successfully");
      })
      .catch( e=>{
        this.logger.debug(" there was  an error adding friend to database",e);
      })
  }
  getFriends () : Promise<Array<Friend>> {
    return new Promise((resolve,reject)=> {
       let friends = [];
            this.init().then(()=>{
                let result = this.databaseObj.executeSql("select * from friends", []).then(
                    data=>{
                        if(data.rows.length > 0) {
                            for ( var i = 0 ; i < data.rows.length; i++){
                                friends.push(new Friend(data.rows.item(i)));
                            }
                        }
                        resolve(friends);
                    }).catch((Exception)=>{
                        this.logger.debug("error table of friends", Exception);
                    });
                })
    });
}
  init() : Promise<any> {
    return new Promise((resolve,reject)=>{
        if(this.databaseObj != undefined)
            resolve(this.databaseObj);
        else
           super.init().then(databaseObj=>{
               resolve(databaseObj);
           });
    });
  }
  createFriendsTable(){
    this.databaseObj.executeSql('create table  IF NOT EXISTS friends \n\
    (friendID  VARCHAR(32),chatID  VARCHAR(32),email VARCHAR(32) UNIQUE,name VARCHAR(32),family VARCHAR(32))', [])
    .then(() => { 
        this.logger.debug('Executed SQLL');
    })
    .catch(e => {
      this.logger.debug(e)

    });
  }

}
